import script from "./serving-size-calculator-public.vue?vue&type=script&setup=true&lang=js"
export * from "./serving-size-calculator-public.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__